// Soft aurora background for the light premium theme. Fixed, non-interactive.
export default function Aurora() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
      <div className="aurora-blob" style={{ width: 520, height: 520, top: "-10%", left: "-6%", background: "radial-gradient(circle, color-mix(in srgb, var(--brand) 70%, transparent), transparent 65%)" }} />
      <div className="aurora-blob" style={{ width: 460, height: 460, top: "24%", right: "-8%", background: "radial-gradient(circle, color-mix(in srgb, var(--brand-2) 65%, transparent), transparent 65%)", animationDelay: "-9s" }} />
      <div className="aurora-blob" style={{ width: 420, height: 420, bottom: "-12%", left: "34%", background: "radial-gradient(circle, color-mix(in srgb, var(--brand) 50%, transparent), transparent 65%)", animationDelay: "-15s" }} />
      <div
        className="absolute inset-0 opacity-[0.5]"
        style={{
          backgroundImage: "linear-gradient(rgba(15,23,42,.04) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,.04) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage: "radial-gradient(ellipse at 50% 0%, black 40%, transparent 80%)",
        }}
      />
    </div>
  );
}
